import { Badge } from "@/components/ui/badge";
import { PayoutData } from "@/lib/api/mentor-scoring";
import { ColumnDef } from "@tanstack/react-table";
import {
  Avatar,
  AvatarFallback,
} from "@/components/ui/avatar.tsx";
import { getInitials } from "@/lib/utils";



export const columns: ColumnDef<PayoutData>[] = [
  {
    accessorKey: "name",
    header: "Mentor",
    cell: ({ row }) => {
      const name = row.original.name;
      
      return (
        <div className="flex items-center gap-2">
          <Avatar className="h-8 w-8">
            <AvatarFallback className="text-xs">
              {getInitials(name)}
            </AvatarFallback>
          </Avatar>
          <div className="flex items-center gap-1">
            <div className="font-bold">{name}</div>
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: "current_financial_bonus",
    header: "Total Bonus",
    cell: ({ row }) => {
      const bonus = typeof row.original.current_financial_bonus === 'string' 
        ? parseFloat(row.original.current_financial_bonus) || 0 
        : row.original.current_financial_bonus || 0;
      return (
        <div className="max-w-[300px] truncate flex">
          ${bonus.toFixed(2)}
        </div>
      );
    },
  },
  {
    accessorKey: "paid_engagements",
    header: "Paid Engagements",
    cell: ({ row }) => {
      const paidEngagements = Math.max(0, row.original.total_bonus_teens - 20);
      return (
        <div className="max-w-[300px] truncate flex">
          <Badge variant="outline">{paidEngagements}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "total_bonus_teens",
    header: "Total Engagements",
    cell: ({ row }) => {
      return (
        <div className="max-w-[300px] truncate flex">
          <Badge variant="outline">{row.original.total_bonus_teens}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "bonus_per_teen",
    header: "Bonus Per Teen",
    cell: () => {
      return (
        <div className="max-w-[300px] truncate flex">
          $60
        </div>
      );
    },
  },
];
